const cookieService = {
	TERMS_AND_CONDITIONS: 'terms_and_conditions',

	/**
	 * Write a value to the session cookie.
	 * @param {string} key - The key to store.
	 * @param {string} value - The value to store.
	 * @param {number} [minutes=120] - Expiry in minutes (default: 24 hours).
	 */
	write(key, value, minutes = 1440) {
		const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
		document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
	},

	/**
	 * Read the value from the session cookie.
	 * @returns {string|null} The cookie value or null if not set.
	 */
	read(key) {
		const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
		return match ? decodeURIComponent(match[2]) : null;
	},

	/**
	 * Remove the session cookie.
	 */
	remove(key) {
		document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
	}
};

export default cookieService;
